var map = {
	"./google-play-badge-da-DK.svg": 56649,
	"./google-play-badge-de-DE.svg": 61715,
	"./google-play-badge-en-GB.svg": 46041,
	"./google-play-badge-en-US.svg": 24126,
	"./google-play-badge-es-ES.svg": 33381,
	"./google-play-badge-es-MX.svg": 7078,
	"./google-play-badge-fr-FR.svg": 74345,
	"./google-play-badge-it-IT.svg": 28819,
	"./google-play-badge-nb-NO.svg": 43732,
	"./google-play-badge-nl-NL.svg": 2097,
	"./google-play-badge-pl-PL.svg": 90997,
	"./google-play-badge-pt-BR.svg": 74109,
	"./google-play-badge-pt-PT.svg": 10869,
	"./google-play-badge-sv-SE.svg": 31992
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 31724;